import * as Fabric from 'fabric';

Fabric.FabricObject.NUM_FRACTION_DIGITS = 6;
Fabric.FabricObject.customProperties = ['eflex'];

const originalToObject = Fabric.Line.prototype.toObject;

Fabric.Line.prototype.toObject = function (propertiesToInclude) {
  return originalToObject.call(this, ['x1', 'y1', 'x2', 'y2', ...propertiesToInclude]);
};

//TODO: fixed in https://github.com/fabricjs/fabric.js/pull/5487
//this can be removed after update to fabric > v2.6.0 AND
//implementing use of srcFromAttribute flag on Image instances
Fabric.FabricImage.prototype.getSrc = function (filtered) {
  const element = filtered ? this._element : this._originalElement;
  if (element != null) {
    if (element.toDataURL != null) {
      return element.toDataURL();
    }

    return element.getAttribute('src');
  } else {
    return this.src || '';
  }
};

const originalRenderCanvas = Fabric.StaticCanvas.prototype.renderCanvas;

Fabric.StaticCanvas.prototype.renderCanvas = function (ctx, objects) {
  if (!ctx) {
    return;
  }
  originalRenderCanvas.call(this, ctx, objects);
};

const originalClearContext = Fabric.StaticCanvas.prototype.clearContext;

Fabric.StaticCanvas.prototype.clearContext = function (ctx) {
  if (!ctx) {
    return;
  }
  return originalClearContext.call(this, ctx);
};

